/*
   Hook into setting changes in order to change layout.
*/
const location = store => next => action => {
    let result = next(action);
    return result
}

export default location;